<template>
  <!-- テキスト転記画面 -->
  <div id="PDashboardTranscribingTextModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title">テキスト転記</p>
      </header>
      <section class="modal-card-body" style="height: 680px;">
        <div class="header-area">
          <div class="patientname-block">
            <div class="label-area">患者氏名</div>
            <div class="data-area">
              <select v-model="patientExternalId" @change="selectPatientText(patientExternalId)" :disabled="isErrorOccerred" style="margin-top: -8px;">
                <option v-for="selectPatient in copyCheckedRows" :key="selectPatient.patientExternalId" :value="selectPatient.patientExternalId">
                  {{ selectPatient.patientName }}
                </option>
              </select>
            </div>
          </div>
          <div class="patientexternalid-block">
            <div class="label-area">診察券ID</div>
            <div class="data-area">{{ selectedPatientInfo.patientExternalId }}</div>
          </div>
          <div class="templatename-block">
            <div class="label-area">テンプレート名</div>
            <div class="data-area">{{ templateInfo.templateName }}</div>
          </div>
          <div class="content-block">
            <div class="label-area">本文</div>
          </div>
        </div>
        <textarea class="body-area" v-model="selectedPatientInfo.body" type="text" readonly :disabled="isErrorOccerred"/>
      </section>
      <footer class="modal-card-foot">
        <b-button class="is-primary" style="width: 200px; margin-left: auto" @click="clipboardCopy()" :disabled="isErrorOccerred || !selectedPatientInfo.body">クリップボードにコピー</b-button>
        <b-button class="is-primary" @click="$parent.close()">キャンセル</b-button>
      </footer>
    </div>
  </div>
</template>
<script>
const UNEXPECTED_ERROR = "予期しないエラーが発生しました。";
export default {
  name: "PDashboardTranscribingTextModal",
  props: {
    templateId: "",                 // メイン画面から受け取るテンプレートID
    checkedRows: { type: Array  },  // メイン画面から受け取る選択患者情報リスト
  },
  methods: {
    // プルダウンで選択された患者情報を取得
    selectPatientText() {
      this.selectedPatientInfo = this.transcriptionInfoList.find((transcriptionData) => transcriptionData.patientExternalId == this.patientExternalId);
    },
    // クリップボードにコピー 患者が選択されていないときは非活性
    clipboardCopy() {
      navigator.clipboard.writeText(this.selectedPatientInfo.body).then(() => {
          this.showMessage("クリップボードにコピーしました。");
        })
        .catch(() => {
          this.showMessage("コピーに失敗しました");
        });
    },
  },
  data() {
    return {
      isErrorOccerred: false,     // エラーの発生有無
      patientExternalId: "",      // 患者診察券ID
      templateInfo: [],           // テンプレート情報
      itemInfoList: [],           // 項目情報リスト
      replacementResultText: [],  // 本文置換結果テキスト
      transcriptionInfoList: [],  // 転記情報リスト
      selectedPatientInfo: [],    // 選択された患者情報
      copyCheckedRows: {}         // 直接編集しないようにコピーした選択行
    };
  },
  filters: {},
  components: {},
  created() {},
  async mounted() {
    // 直接編集しないように検索結果一覧の選択行をコピー
    this.copyCheckedRows = this.getCopy(this.checkedRows);
    // テンプレート情報取得
    const _this = this;
    _this.templateId = this.templateId;
    await this.apiCall(
      function (client) {
        return client.apis.externalPDashboard.getTextTemplateInfoPOST({
          body: { templateId: _this.templateId },
        });
      },
      function (result) {
        if (result.status == 200) {
          _this.templateInfo = result.obj.textTemplateInfo;
          _this.itemInfoList = result.obj.itemInfoList;
        } else {
          _this.isErrorOccerred = true;
          // エラーメッセージ表示
          _this.showErrorMessage(UNEXPECTED_ERROR);
        }
      },
      function (error) {
        _this.isErrorOccerred = true;
        // エラーメッセージ表示
        _this.showErrorMessage(error);
      }
    );

    // テンプレートへ置換
    try {
      // 診察券ID昇順でソート
      this.copyCheckedRows.sort((a, b) => a.patientExternalId < b.patientExternalId ? -1 : 1);
      for (let patient of this.copyCheckedRows) {
        let isFirstReplacement = true;
        let patientItemInfoList = [];
        for (let itemInfo of this.itemInfoList) {
          patientItemInfoList.push({
            itemName: itemInfo.itemName,
            itemValue: patient[itemInfo.itemId],
          });
        }
        for (let targetItem of patientItemInfoList) {
          targetItem.itemValue = targetItem.itemValue == null ? "" : targetItem.itemValue;
          // 1回目のみtemplateInfo.textを置換
          // 2回目以降は置き換えたreplacementResultTextを置換
          if (isFirstReplacement) {
            this.replacementResultText = this.templateInfo.text.replaceAll("$" + targetItem.itemName + "$", targetItem.itemValue);
            isFirstReplacement = false;
          } else {
            this.replacementResultText = this.replacementResultText.replaceAll("$" + targetItem.itemName + "$", targetItem.itemValue);
          }
        }
        this.transcriptionInfoList.push({
          patientId: patient.patientId,
          patientExternalId: patient.patientExternalId,
          patientName: patient.patientName,
          body: this.replacementResultText,
        });
      }
    } catch (error) {
      this.isErrorOccerred = true;
      // エラーメッセージ表示
      this.showErrorMessage(UNEXPECTED_ERROR);
    }
    // 置換後のtranscriptionInfoListの一番上のレコードを初期表示とする
    this.selectedPatientInfo = this.transcriptionInfoList.find((transcriptionData) => transcriptionData.patientExternalId == this.transcriptionInfoList[0].patientExternalId);
    this.patientExternalId = this.transcriptionInfoList[0].patientExternalId;
    // メイン画面ですべて選択ボタン押下後テキスト転記画面を開くと、検索結果一覧のヘッダが消えるためカラムを再設定(b-tableのバグ対応)
    this.$emit("reDisplayColumns");
  },
};
</script>
<style lang="scss" scoped>
.header-area {
  width: 50%;
  margin-top: -10px;
  font-size: 16px;
}
.patientname-block, .patientexternalid-block, .templatename-block, .content-block {
  display: grid;
  grid-template-columns: 150px 1fr;
  text-align: left;
  padding-top: 10px;
  height: 36px;
}
.label-area {
  font-weight: bold;
  color: #061e57;
}
.body-area {
  display: block;
  resize: none;
  width: 100%;
  height: 505px;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/patientdashboard/PDashboardTranscribingTextModal.vue